import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { applicationCards } from '../../data/products';
export function ApplicationsSection() {
  return <section aria-labelledby="applications-heading" className="w-full border-y border-rule bg-white" data-id="element-104" data-mp="5uxd15ridwvq">
      <div className="mx-auto max-w-shell px-5 py-16 lg:px-10 lg:py-24" data-id="element-105" data-mp="yyl586z1wqk">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:gap-20" data-id="element-106" data-mp="39cnzb9j1yh9g">
          <SectionHeading id="applications-heading" eyebrow="APPLICATIONS" heading="Start with the material and the chip-control problem" data-id="element-107" data-mp="34evwvlks7cr0" />
          <p className="rp-measure self-end text-[15.5px] leading-[1.7] text-graphite/80" data-id="element-108" data-mp="3eaphztckgeke">
            The insert choice and starting parameters change with the work
            material, machine power, workholding and desired chip. Use the paths
            below to orient the setup, then confirm the application with sales.
          </p>
        </div>

        <ul className="mt-14 grid gap-6 lg:grid-cols-3 lg:gap-5" data-id="element-109" data-mp="dfvvbpru8h9w">
          {applicationCards.map(app => <li key={app.heading} className="flex" data-id="element-110" data-mp="iefgvp2irr1q">
              <article className="flex w-full flex-col border border-rule bg-white" data-id="element-111" data-mp="ifqh5ewrago3">
                <figure className="relative m-0 aspect-[4/3] w-full overflow-hidden border-b border-rule bg-navy" data-id="element-112" data-mp="mg0oow075f52">
                  <img src={app.image} alt={app.imageAlt} width={1200} height={900} loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
                objectPosition: app.objectPosition
              }} data-id="element-113" data-mp="3ltkvgn73319s" />
                  <figcaption className="absolute bottom-3 left-3 inline-flex items-center gap-2 border border-white/25 bg-navy/80 px-2.5 py-1.5 font-mono text-[9px] leading-none tracking-label text-aluminum backdrop-blur-sm" data-id="element-114" data-mp="334ochfh4zv6v">
                    <span aria-hidden="true" className="h-px w-3 bg-copper" data-id="element-115" data-mp="e9y983zb9a8w" />
                    ILLUSTRATIVE APPLICATION VIEW
                  </figcaption>
                </figure>

                <div className="flex flex-1 flex-col p-6 lg:p-7" data-id="element-116" data-mp="o1azws9dhudc">
                  <h3 className="font-display text-[24px] font-medium leading-tight text-navy" data-id="element-117" data-mp="j42jox7sc0eq">
                    {app.heading}
                  </h3>
                  <p className="mt-4 text-[14.5px] leading-[1.65] text-graphite/80" data-id="element-118" data-mp="3rknsoe0f2thu">
                    {app.copy}
                  </p>
                  <p className="mt-6 inline-flex self-start border border-rule bg-warm px-3 py-1.5 font-mono text-[10px] leading-relaxed tracking-label text-graphite" data-id="element-119" data-mp="4edcold0h26j">
                    {app.technicalLabel}
                  </p>
                  <Link to={app.href} data-analytics="product-category-click" data-analytics-label={app.heading} className="mt-auto inline-flex min-h-[44px] items-center gap-2 self-start border-b border-copper pt-8 text-[14px] font-semibold text-navy transition-colors duration-150 ease-precise hover:text-copper" data-id="element-120" data-mp="1frpd0m9kb2ny">
                    {app.linkLabel}
                    <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-121" data-mp="1ebl899j01oly" />
                  </Link>
                </div>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}